import React from 'react';
import {getStoredData} from "../../JsonFiles/fetchData";
import DynamicForm from '../../components/DynamicForm/DynamicForm';

const AddProjectsPage = () => {
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminProjects : {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/projects'; // API endpoint for creating product
  const successRedirect = '/admin/projects'; // Redirect after successful product creation

  return (
    <div>
      <DynamicForm fields={fields} apiUrl={apiUrl} successRedirect={successRedirect} />
    </div>
  );
};

export default AddProjectsPage;